




































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import Application from "@/state/Application";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import {
	AddressLocationOption,
	BranchLocationOption, LocationOption,
	ProjectLocationOption
} from "@/components/payroll/business/services/ServiceDTO";
import {processError} from "@/utils/ComponentUtils";
import LocationSliderBuilder from "@/components/payroll/business/services/locations/LocationSliderBuilder.vue";
import {IProfile} from "@/dto/IProfile";

@Component({
	components: {LocationSliderBuilder, RightSideBar}
})
export default class LocationSliderSelector extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	@Prop({default: null})
	private contact!: IProfile | null

	private createLocation = false

	private locations: Array<LocationOption> = []

	mount(visible: boolean) {
		if (visible) {
			Application.startLoading()
			this.loadAllLocations()
				.finally(Application.stopLoading)
		}
	}

	private loadAllLocations() {
		return ServiceLogOrchestrator.getLocationsByExecutorId(this.$wss.getCurrent.id, this.contact?.id).then(
			res => {
				if (res.data.addresses.length == 0 && res.data.branches.length == 0  && res.data.projects.length == 0) return;
				this.locations = res.data.addresses.map(it => new AddressLocationOption(it))
				this.locations = [...this.locations, ...res.data.branches.map(it => new BranchLocationOption(it))]
				this.locations = [...this.locations, ...res.data.projects.map(it => new ProjectLocationOption(it))]
				return;
			},
			err => processError(err, this)
		)
	}

	selectLocation(location: LocationOption) {
		this.$emit("selected", location)
		this.$emit("input", false)
	}

	private create(location: AddressLocationOption) {
		this.locations = [location, ...this.locations]
		this.selectLocation(location)
	}

}
